import { render, staticRenderFns } from "./kid_form.vue?vue&type=template&id=2aacf6c8"
import script from "./kid_form.vue?vue&type=script&lang=js"
export * from "./kid_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports